import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=02d7bfa5&scoped=true&"
import script from "./PermissionModal.vue?vue&type=script&lang=js&"
export * from "./PermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=02d7bfa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d7bfa5",
  null
  
)

export default component.exports